import { ToolbarDivider } from '@fluentui/react-components';
import InsertCaptionButton from '../caption/insert/InsertCaptionButton';
import WrapToggleButton from '../elementRow/WrapToggleButton';

// Container for image node settings
const ImageNodeTabContent = () => {
  return (
    <>
      <WrapToggleButton />

      <ToolbarDivider />

      <InsertCaptionButton />
    </>
  );
};

export default ImageNodeTabContent;
